// LeadForm.jsx

import React, { useRef, useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import './LeadForm.css'; 
//import PdfEditor from './PdfEditor';
import { generatePdf } from './PdfGenerator';
import Loader from './Loader';
import { createRoot } from 'react-dom/client';

const LeadForm = (userData) => {
  const axiosDomain = process.env.REACT_APP_AXIOS_DOMAIN;
  const navigate = useNavigate();
  const sigCanvas = useRef(null);    
  const [triggerPreview, setTriggerPreview] = useState(false);  
  const [formData, setFormData] = useState({
    title: '',
    first_name: '',
    last_name: '',    
    date_of_birth: '',    
    current_address_line_1: '',
    current_address_line_2: '',
    current_address_line_3: '',
    current_address_line_4: '',
    current_post_code: '',
    previous_names: '',    
    credit_agreement_number: '',
    car_dealership_name: '',
    vehicle_registration_number: '',
    lender: '',    
    email: '',
    telephone: '',
    mobile: '',
    updated_info: '',
    cancel_request: '',
    // addlenders: [],
    // addcredits: [],
    // adddealerships: [],
    // addvehicles: [],
    // addcases: [],
    ip: '',
    previousadds: [],
    question1: '',
    question2: '',
    question3: '',
    selectedLender: '',
    signup_caseid: ''
  });

  // New States for Confirmation
  const [confirmedFields, setConfirmedFields] = useState({});
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [caseId, setCaseId] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('tk');
  // const [pdfBytes, setPdfBytes] = useState(null);
  const [prevAddresses, setPrevAddresses] = useState([]);  
  const [prevAdd, setPrevAdd] = useState({
    previous_address_line_1: '',
    previous_address_line_2: '',
    previous_address_line_3: '',
    previous_address_line_4: '',
    previous_post_code: ''
  });
  const [prevNames, setPrevNames] = useState([]);
  const [prevName, setPrevName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [checkFieldErrors, setCheckFieldErrors] = useState([]);
  const [nameChanged, setNameChanged] = useState(false);
  const [originalFirstName, setOriginalFirstName] = useState('');
  const [originalLastName, setOriginalLastName] = useState('');

  const lenderOptions = [
    "247 Money",
    "Advantage Finance",
    "ALD Automotive",
    "Aldermore Bank",
    "Alfa Romeo Financial Services",
    "Alphera Financial Services",
    "Arval UK",
    "Audi Financial Services",
    "Auto Union Finance",
    "Autobank Financial Services",
    "AutoMoney Motor Finance",
    "Barclays Partner Finance",
    "Billing Finance",
    "Black Horse",
    "Blue Motor Finance",
    "BMW Financial Services",
    "Borderway Finance",
    "Car Finance 247",
    "Chrysler",
    "Citroen UK Limited",
    "Close Brothers Motor Finance",
    "CLS Finance",
    "Clydesdale Financial Services",
    "Creation Consumer Finance Limited",
    "Evolution Funding",
    "Family Finance",
    "FCA Automotive Services",
    "FCE Bank plc",
    "FERRARI FINANCIAL SERVICES GMBH",
    "Fiat Financial Services",
    "FinanceU",
    "First Response Finance",
    "FirstRand Bank",
    "FirstRand Bank Limited (London Branch)",
    "Ford Credit",
    "GMAC UK PLC",
    "Go Car Credit",
    "H&H Finance Limited",
    "Hampshire Trust Bank",
    "Hitachi Capital",
    "Hitachi Personal Finance",
    "Honda Financial Services",
    "Hyundai Finance",
    "Jaguar Financial Services",
    "JBR Capital Limited",
    "Kia Finance",
    "Land Rover Financial Services",
    "LeasePlan",
    "Lexus Financial Services",
    "Mann Island Finance",
    "Marsh Finance",
    "Marsh Finance Limited",
    "Mazda Financial Services",
    "Mercedes-Benz Finance",
    "MINI Financial Services",
    "Moneybarn Limited",
    "Moneyway",
    "MotoNovo Finance",
    "Nissan Finance",
    "Northridge Finance",
    "Novuna Personal Finance",
    "Oodle Car Finance",
    "Paragon",
    "PCF Bank",
    "Peugeot Financial Services",
    "Polesworth Motor Finance",
    "Porsche Financial Services",
    "Premium Plan",
    "PSA Finance UK",
    "RateSetter",
    "RBS",
    "RCI Financial Services",
    "Renault Finance",
    "Santander Consumer Finance",
    "SEAT Financial Services",
    "Secure Trust Bank",
    "Shogun Finance",
    "Skoda Financial Services",
    "Specialist Motor Finance",
    "Startline Motor Finance",
    "Stellantis Financial Services UK",
    "Suzuki Financial Services",
    "The Car Finance Company",
    "Toyota Financial Services",
    "Vauxhall Finance",
    "Volkswagen Financial Services",
    "Volvo Car Financial Services"
];



  useEffect(() => {
    if (userData && userData.userData) {
      setFormData({
        title: userData.userData.title || '',
        first_name: userData.userData.first_name || '',
        last_name: userData.userData.last_name || '',        
        date_of_birth: userData.userData.date_of_birth || '',        
        current_address_line_1: userData.userData.current_address_line_1 || '',
        current_address_line_2: userData.userData.current_address_line_2 || '',
        current_address_line_3: userData.userData.current_address_line_3 || '',
        current_address_line_4: userData.userData.current_address_line_4 || '',
        current_post_code: userData.userData.current_post_code || '',
        previous_names: userData.userData.previous_names || '',        
        credit_agreement_number: userData.userData.credit_agreement_number || '',
        car_dealership_name: userData.userData.car_dealership_name || '',
        vehicle_registration_number: userData.userData.vehicle_registration_number || '',
        lender: userData.userData.lender || '',        
        email: userData.userData.email || '',
        telephone: userData.userData.telephone || '',
        mobile: userData.userData.mobile || '',
        updated_info: userData.userData.updated_info || '0',
        cancel_request: '0',
        // addlenders: userData.userData.addlenders || [],
        // addcredits: userData.userData.addcredits || [],
        // adddealerships: userData.userData.adddealerships || [],
        // addvehicles: userData.userData.addvehicles || [],
        // addcases: userData.userData.addcases || [],
        ip: userData.userData.ip || '',
        previousadds: userData.userData.previousadds || [],
        question1: userData.userData.question1 || '',
        question2: userData.userData.question2 || '',
        question3: userData.userData.question3 || '',
        selectedLender: userData.userData.lender || '',
        signup_caseid: userData.userData.signup_caseid || ''

      });
      setOriginalFirstName(userData.userData.first_name || '');
      setOriginalLastName(userData.userData.last_name || '');      

      setCaseId(userData.userData.case_id || '');            
      if (userData.userData.previousadds && userData.userData.previousadds.length > 0) {
        setPrevAddresses(userData.userData.previousadds);
      }             
      if (userData.userData.previous_names && userData.userData.previous_names !== '') {
        setPrevNames(userData.userData.previous_names.split(','));
      }      
    }                    
  }, [userData]);

  const handleCheckboxChange = () => {
    setTermsAccepted(!termsAccepted);
  };

  const handlePrevAddChange = (e) => {
    const { name, value } = e.target;
    setPrevAdd({
      ...prevAdd,
      [name]: value
    });
  };  

  const addPreviousAddress = () => {    
    const newAdd = {
      previous_address_line_1: prevAdd.previous_address_line_1,
      previous_address_line_2: prevAdd.previous_address_line_2,
      previous_address_line_3: prevAdd.previous_address_line_3,
      previous_address_line_4: prevAdd.previous_address_line_4,
      previous_post_code: prevAdd.previous_post_code
    };
    const newAdds = [...prevAddresses, newAdd];
    setPrevAddresses(newAdds);
    setPrevAdd({
      previous_address_line_1: '',
      previous_address_line_2: '',
      previous_address_line_3: '',
      previous_address_line_4: '',
      previous_post_code: ''
    });
    setFormData({
      ...formData,
      previousadds: newAdds      
    })
  };

  const removePreviousAddress = (index) => {    
    const newAddresses = [...prevAddresses];
    newAddresses.splice(index, 1);
    setPrevAddresses(newAddresses);
    setFormData({
      ...formData,
      previousadds: newAddresses
    });
  };

  const handlePrevNameChange = (e) => {
    setPrevName(e.target.value);
  };

  const addPreviousName = () => {
    const existingNames = prevNames;
    const NewNames = existingNames + ',' + prevName;
    
    setPrevNames([...prevNames, prevName]);
    setFormData({
      ...formData,
      previous_names: NewNames
    });    
    setPrevName('');
  };

  const removePreviousName = (index) => {
    const newNames = [...prevNames];
    newNames.splice(index, 1);
    setPrevNames(newNames);
    setFormData({
      ...formData,
      previous_names: newNames.join(',')
    });
  };

  // const pdfEditorRef = useRef();
  
  const handleSubmit = async (e) => {
    e.preventDefault();    
    
    const checkFields = ['title', 'first_name', 'last_name', 'date_of_birth', 'telephone', 'mobile', 'current_address_line_1',
                          'current_address_line_2', 'current_address_line_3', 'current_address_line_4', 'current_post_code'];
    //Checking if the non-blank fields have been confirmed
    let checkErrors = [];
    checkFields.forEach(field => {            
      if (formData[field] && formData[field] !== '') {        
        if (!confirmedFields[field]) {          
          setError('Please confirm all fields with values.');
          checkErrors.push(field);
          return;
        }
      }
    });

    setCheckFieldErrors(checkErrors);
    if (!formData.date_of_birth) {
      setError('Please enter your date of birth.');
      return;
    }

    if (!formData.mobile || formData.mobile === '') {
      setError('Please enter your mobile number.');
      return;
    }

    if (!formData.selectedLender || formData.selectedLender === '' || formData.selectedLender.length < 2 || formData.selectedLender === 'Select Lender' || formData.selectedLender === 'Other' || formData.selectedLender === 'null' || formData.selectedLender === 'undefined') {      
      setError('Please select a lender.');
      return;
    }

    if (!formData.question1 || !formData.question2 || !formData.question3) {
      setError('Please answer all the mandatory questions.');
      return;
    }

    if (checkErrors.length > 0) {
      return;
    }        

    if (!termsAccepted) {
      setError('Declaration box not checked.');
      return;
    }    

    if (!formData.first_name || !formData.last_name || !caseId) {
      setError('Please fill out all required fields.');
      return;
    }

    setIsLoading(true);
    const data = new FormData();    
    data.append('caseId', caseId);
    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        if (typeof formData[key] === 'object') {
          data.append(key, JSON.stringify(formData[key]));
        } else {
          data.append(key, formData[key]);     
        }        
      }
    }
    
    if (sigCanvas.current.isEmpty()) {
      setError('Please provide a signature.');
      return;
    }

    // sigCanvas.current.getTrimmedCanvas().toBlob(async (blob) => {
    //   data.append('signature', blob, 'signature.png');
    // }, 'image/png');

    const signatureBlob = await new Promise((resolve) => {
      sigCanvas.current.getTrimmedCanvas().toBlob(resolve, 'image/png');
    });

    const signatureFile = new File([signatureBlob], 'sign.png', { type: 'image/png' });
    
    let pdfBytes;
    let newCaseId;
    try {                        
      const response = await axios.post(`${axiosDomain}/api/leads/BOCaseCreation?token=${token}`, formData);
      if (response.data.caseReference) {
        newCaseId = response.data.caseReference;
        const updatedFormData = { ...formData, signup_caseid: newCaseId };
        setFormData(updatedFormData);
        
        const signatureArrayBuffer = await signatureBlob.arrayBuffer();
        pdfBytes = await generatePdf(updatedFormData, signatureArrayBuffer, prevAddresses, prevNames);
        
        data.append('newcaseId', response.data.caseReference);
        
        //const updatedFormData = { ...formData, signup_caseid: newCaseId };
        //setPdfBytes(null);
      } else {
        throw new Error('Case not created');
      }
    } catch (error) {
      setError('Sorry, your response could not be processed. Please check back with us later.');
      setIsLoading(false);
      return;
    }            

    data.append('signature', signatureFile, `signature.png`);

    if (pdfBytes) {
      pdfBytes.loaPDFs.forEach((doc) => {
        const pdfBlob = new Blob([doc.data], { type: 'application/pdf' });
        console.log('Sign_up_caseId before saving PDF:', formData.signup_caseid);
        data.append(`ClaimPack`, pdfBlob, `${newCaseId}_${formData.last_name}_${formData.selectedLender}_Claim_Pack.pdf`);
      });
      pdfBytes.coaPDFs.forEach((doc) => {
        const pdfBlob = new Blob([doc.data], { type: 'application/pdf' });
        data.append(`COA`, pdfBlob, `${newCaseId}_${formData.last_name}_${formData.selectedLender}_COA.pdf`);
      });
      if (pdfBytes.appendixPDFs) {
        pdfBytes.appendixPDFs.forEach((doc) => {
          const pdfBlob = new Blob([doc.data], { type: 'application/pdf' });
          data.append(`Appendix`, pdfBlob, `Appendix.pdf`);
        });
      }                
    }
      
    try {                        
      const response = await axios.post(`${axiosDomain}/api/leads/submit?token=${token}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      localStorage.setItem('userData', JSON.stringify(formData));
      setMessage(response.data.message);
      setIsLoading(false);
      setError('');
      resetForm();
      
      navigate('/optional-documents/?tk=' + token);
    } catch (error) {
      if (error.response && error.response.data.includes('Duplicate entry')) {
        setError('Submission failed: Duplicate entry.');
        setIsLoading(false);
      } else {
        setError('Submission failed: ' + error.message);
        setIsLoading(false);
      }
      setMessage('');
    }    
  };

  const clearSignature = () => {
    sigCanvas.current.clear();
  };

  const resetForm = () => {
    setFormData({
      title: '',
      first_name: '',
      last_name: '',      
      date_of_birth: '',      
      current_address_line_1: '',
      current_address_line_2: '',
      current_address_line_3: '',
      current_address_line_4: '',
      current_post_code: '',
      previous_names: '',      
      credit_agreement_number: '',
      car_dealership_name: '',
      vehicle_registration_number: '',
      lender: '',      
      email: '',
      telephone: '',
      mobile: '',
      updated_info: '',
      cancel_request: '',
      // addlenders: [],
      // addcredits: [],
      // adddealerships: [],
      // addvehicles: [],
      // addcases: [],
      previousadds: [],
      ip: '',
      question1: '',
      question2: '',
      question3: '',
      selectedLender: '',
      signup_caseid: ''

    });
    clearSignature();
    setTermsAccepted(false);
    setConfirmedFields({});
  };

  const handleChange = (e, index) => {
    const { name, value, type } = e.target;
     if (type === 'radio') {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    

    if (name === 'first_name' || name === 'last_name') {
      if (name === 'first_name') {
        if (value !== originalFirstName) {
          setNameChanged(true);
        } else {
          setNameChanged(false);
        }
      } else if (name === 'last_name') {
        if (value !== originalLastName) {
          setNameChanged(true);
        } else {
          setNameChanged(false);
        }
      }
    }      

    if (name.includes('credit_agreement_number')) {        
      const nameIndex = name.replace('credit_agreement_number', '')                
      const creditIndex = Number(nameIndex);
      const newCredits = [...formData.addcredits];
      newCredits[creditIndex].credit_agreement_number = value;
      setFormData({
        ...formData,
        addcredits: newCredits
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
        updated_info: '1'
      });
    }


    if (name === 'lender') {
      if (value !== 'Other') {        
        setFormData({
          ...formData,
          lender: value,
          selectedLender: value
        });
      }
    }
    if (name === 'OtherLender') {
      setFormData({
        ...formData,
        selectedLender: value
      })
    }
  };

  const handleFieldConfirmation = (fieldName) => {
    setConfirmedFields({
      ...confirmedFields,
      [fieldName]: true
    });
    if (checkFieldErrors.includes(fieldName)) {
      setCheckFieldErrors(checkFieldErrors.filter(field => field !== fieldName));
    }
  };

  const RenderFieldWithConfirmation = (label, name, type = "text") => {
    const hasValue = formData[name] && formData[name] !== '';
    const isConfirmed = confirmedFields[name];
    return (
      <div className="form-group">
        <label>{label}:</label>
        <input
          type={type}
          name={name}
          value={formData[name]}
          onChange={(e) => {
            handleChange(e);
            // Reset confirmation if value changes
            setConfirmedFields({
              ...confirmedFields,
              [name]: false
            });
          }}
          className={`${hasValue && !isConfirmed ? 'highlight' : ''} ${checkFieldErrors.includes(name) ? 'checkerror' : ''}`}
        />
        {hasValue && (
          <button
            type="button"
            className={`confirm-button ${isConfirmed ? 'confirmed' : ''}`}
            onClick={() => handleFieldConfirmation(name)}
          >
            {'✓'}
          </button>
        )}
      </div>
    );
  };
  
  return (    
    <>
    {isLoading ? (
      <>        
        <Loader />          
      </>
      ) : (
      <>      
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
              <div className="form-row">
                <div className="form-section row1col1">
                  <label>Email:</label>
                  <p>{formData.email}</p>              
                  <br/>           
                </div>
                <div className="form-section row1col2">              
                  <p className="header-note">
                    Please provide as much detail as possible in the fields on this screen.<br/><br/>
                    If any detail is incorrect please type over the current information and add any detail that is missing. <br/><br/>
                    The detail you enter is used by lenders to trace your accounts/records so they can release to us the detail about your PCP agreement we need to progress your claim. <br/><br/>
                    Lenders use previous addresses and previous names to trace records so please add all the detail you can. <br/><br/>
                    An account number would be extremely beneficial.  
                  </p>                  
                </div>
              </div>
          </div>
          <div className="form-row">                
              
            <div className="user-details form-section">                    
                <h3>User Details <span className="text-with-heading">(Please click all the checkboxes to confirm the information)</span></h3>   
                                                     
                {RenderFieldWithConfirmation('Title', 'title')}
                {RenderFieldWithConfirmation('First Name', 'first_name')}
                {RenderFieldWithConfirmation('Last Name', 'last_name')}
                {RenderFieldWithConfirmation('Date of Birth', 'date_of_birth', 'date')}
                {RenderFieldWithConfirmation('Telephone', 'telephone')}
                {RenderFieldWithConfirmation('Mobile', 'mobile')}
            </div>

            <div className="address-details form-section">
                <h3>Address Details</h3>
                {RenderFieldWithConfirmation('Current Address Line 1', 'current_address_line_1')}
                {RenderFieldWithConfirmation('Current Address Line 2', 'current_address_line_2')}
                {RenderFieldWithConfirmation('Current Address Line 3', 'current_address_line_3')}
                {RenderFieldWithConfirmation('Current Address Line 4', 'current_address_line_4')}
                {RenderFieldWithConfirmation('Current Post Code', 'current_post_code')}
                
            </div>                                                                 
          </div>
          <div className="form-row">                
            <div className="prev-address-details form-section">
                <h3>Previous Address Details</h3>
                <span className="title-text">If you have more than one previous address, please add them to the list.</span>
                <br/><br/>

                <div className="form-group">
                    <label>Previous Address Line 1:</label>
                    <input type="text" name="previous_address_line_1" value={prevAdd.previous_address_line_1} onChange={handlePrevAddChange} />
                </div>
                <div className="form-group">
                    <label>Previous Address Line 2:</label>
                    <input type="text" name="previous_address_line_2" value={prevAdd.previous_address_line_2} onChange={handlePrevAddChange} />
                </div>
                <div className="form-group">
                    <label>Previous Address Line 3:</label>
                    <input type="text" name="previous_address_line_3" value={prevAdd.previous_address_line_3} onChange={handlePrevAddChange} />
                </div>
                <div className="form-group">
                    <label>Previous Address Line 4:</label>
                    <input type="text" name="previous_address_line_4" value={prevAdd.previous_address_line_4} onChange={handlePrevAddChange} />
                </div>
                <div className="form-group">
                    <label>Previous Post Code:</label>
                    <input type="text" name="previous_post_code" value={prevAdd.previous_post_code} onChange={handlePrevAddChange} />
                </div>                    
                <button type="button" className="paddbutton" onClick={() => addPreviousAddress()}>Add Previous Address</button>                
            </div>                                            
            <div className="prev-address-table form-section">
              <h3>Previous Addresses</h3>
              <table className="prev-add-table">
                <thead>
                  <tr>
                    <th className="padd1">#</th>
                    <th className="padd2">Line 1</th>
                    <th className="padd3">Line 2</th>
                    <th className="padd4">Line 3</th>
                    <th className="padd5">Line 4</th>
                    <th className="padd6">Post Code</th>
                    <th className="padd7">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {prevAddresses.map((address, index) => (
                    <tr key={index}>
                      <td className="padd1">{index + 1}</td>
                      <td className="padd2">{address.previous_address_line_1}</td>
                      <td className="padd3">{address.previous_address_line_2}</td>
                      <td className="padd4">{address.previous_address_line_3}</td>
                      <td className="padd5">{address.previous_address_line_4}</td>
                      <td className="padd6">{address.previous_post_code}</td>
                      <td className="padd7">
                        <a href="#!" onClick={() => removePreviousAddress(index)}>Delete</a>                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>                
            </div>
          </div>

          <div className="form-row">            
            <div className="matter-details form-section">
                <h3>Case Related Details</h3>
                <span className="important-note title-text">Please note this is your lender’s agreement number, NOT our reference beginning with CA.<br/><br/></span>
                
                                                                                            
                {/* { */}
                   {/* formData.addvehicles.map((vehicle, index) => (                       */}
                    {/* <React.Fragment key={index}> */}
                    <div className="form-group">
                        <label>Lender:</label>
                        <select name="lender" value={formData.lender} onChange={handleChange}>
                          <option value="" disabled>Select Lender</option>
                          {lenderOptions.map((lender, index) => (
                            <option key={index} value={lender}>{lender}</option>
                          ))}
                          <option value="Other">Other</option>
                        </select>
                        {formData.lender === 'Other' && (
                          <>
                          <label>Other Lender:</label>
                          <input type="text" name="OtherLender" value={formData.selectedLender} onChange={handleChange} />
                          </>
                        )}
                    </div>
                    
                    
                    
                    <div className="form-group">
                        <label>Car Dealership Name:</label>
                        <input type="text" name="car_dealership_name" value={formData.car_dealership_name} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <label>Vehicle Registration Number:</label>
                        <input type="text" name="vehicle_registration_number" value={formData.vehicle_registration_number} onChange={handleChange} />
                    </div> 
                    {/* </React.Fragment> */}
                  {/* ))
                }                     */}
            </div>    

            <div className="previous-names form-section">
                <h3>Previous Names</h3>
                <div className="form-group pnamegroup">
                  <div className="pnameinput">
                    <label>Add a name:</label>
                    <input type="text" value={prevName} onChange={handlePrevNameChange} />                    
                    <div className="pnamebutton">
                      <button type="button" onClick={addPreviousName}>Add Previous Name</button>
                    </div>
                  </div>                  
                </div>
                <div className="prev-names-table">
                  <table className="prev-name-table">
                    <thead>
                      <tr>
                        <th className="padd1">#</th>
                        <th className="padd2">Previous Name</th>
                        <th className="padd3">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {prevNames.map((name, index) => (
                        <tr key={index}>
                          <td className="padd1">{index + 1}</td>
                          <td className="padd2">{name}</td>
                          <td className="padd3">
                            <a href="#!" onClick={() => removePreviousName(index)}>Delete</a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>                
            </div>

            {/* New Mandatory Questions Section */}
            <div className="questions-section form-section">
              <h3>Please answer the following questions:</h3>
              <ol>
                <li>
                  Did the car dealership(s) tell you about the commission they received for arranging the finance to purchase your vehicle?
                  <div className="form-group questions">
                    <input 
                      type="radio" 
                      id="q1_yes" 
                      name="question1" 
                      value="yes" 
                      onChange={handleChange} 
                      required
                      className="optioncheck" 
                    />
                    <label htmlFor="q1_yes" className="optionlabel">Yes</label>

                    <input 
                      type="radio" 
                      id="q1_no" 
                      name="question1" 
                      value="no" 
                      onChange={handleChange} 
                      required 
                    />
                    <label htmlFor="q1_no">No</label>
                  </div>
                </li>
                <li>
                  Have you already submitted a PCP claim for your vehicle(s)?
                  <div className="form-group questions">
                    <input 
                      type="radio" 
                      id="q2_yes" 
                      name="question2" 
                      value="yes" 
                      onChange={handleChange} 
                      required 
                    />
                    <label htmlFor="q2_yes">Yes</label>

                    <input 
                      type="radio" 
                      id="q2_no" 
                      name="question2" 
                      value="no" 
                      onChange={handleChange} 
                      required 
                    />
                    <label htmlFor="q2_no">No</label>
                  </div>
                </li>
                <li>
                  Are you currently in an IVA, bankruptcy or other debt management arrangement?
                  <div className="form-group questions">
                    <input 
                      type="radio" 
                      id="q3_yes" 
                      name="question3" 
                      value="yes" 
                      onChange={handleChange} 
                      required 
                    />
                    <label htmlFor="q3_yes">Yes</label>

                    <input 
                      type="radio" 
                      id="q3_no" 
                      name="question3" 
                      value="no" 
                      onChange={handleChange} 
                      required 
                    />
                    <label htmlFor="q3_no">No</label>
                  </div>
                </li>
              </ol>
            </div>
            {/* End of Questions Section */}

          </div>    

        <div className="form-row signaturerow"> 
            <div className="signature-details form-section">
            <div className="form-group">
                <div className="sample-pack">
                  <p>By entering your signature you are agreeing to be bound by the terms and conditions set out in our retainer documentation which you can view by clicking this <a className="sample-link" href="/sample_pack.pdf" target="_blank" rel="noreferrer">link</a> </p>
                </div>
                <label>Signature:</label>
                <div className="signature-pad">
                  <SignatureCanvas ref={sigCanvas} canvasProps={{ width: 400, height: 200, className: 'sigCanvas' }} />
                </div>
                <span className="important-note">*Please sign in the box above.</span><br/>
                <button type="button" onClick={clearSignature}>Clear Signature</button>
            </div>
            </div>      
        </div>
        
        {/* {formData.signup_caseid && (
          <div className="pdf-embed form-section">          
            <PdfEditor 
                formData={formData}               
                signatureData={sigCanvas.current && !sigCanvas.current.isEmpty() ? sigCanvas.current.getCanvas().toDataURL('image/png') : null}
                onPdfGenerated={setPdfBytes} 
                triggerPreview={triggerPreview}
                PreviousAddresses={prevAddresses}
                PreviousNames={prevNames}
            />
          </div>                
        )} */}

          <div className="form-group checkbox-group">
            <input type="checkbox" checked={termsAccepted} onChange={handleCheckboxChange} />
            <label>I declare that all information provided herein is true, complete, and correct to the best of my knowledge and belief.</label>
          </div>
          <button type="submit">Submit</button>
          {message && <p className="message success">{message}</p>}
          {error && <p className="message error">{error}</p>}
        </form>
      </div>      
    </>
    )}  
    </>
  );
};

export default LeadForm;
